(function () {
  var SECTION_SELECTOR = '.oddit-section-product-faqs';
  var ITEM_SELECTOR = '.oddit-section-product-faqs__item';

  function handleToggle(e) {
    var openedItem = e.currentTarget;
    if (!openedItem.open) return;

    var section = openedItem.closest(SECTION_SELECTOR);
    if (!section) return;

    var items = section.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== openedItem && items[i].open) {
        items[i].open = false;
      }
    }
  }

  function initSection(section) {
    var items = section.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('toggle', handleToggle);
    }
  }

  function destroySection(section) {
    var items = section.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      items[i].removeEventListener('toggle', handleToggle);
    }
  }

  var sections = document.querySelectorAll(SECTION_SELECTOR);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();